import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { mediaUrl } from "@/lib/media";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

function priceLabel(j) {
  const cur = j.currency || "GBP";
  const sym = cur === "GBP" ? "£" : cur === "USD" ? "$" : cur === "EUR" ? "€" : "";
  const n = Number(j.from_price_gbp || 0);
  if (!n) return "Price on application";
  const formatted = sym ? `${sym}${n.toLocaleString()}` : `${n.toLocaleString()} ${cur}`;
  return `From ${formatted}${j.price_note ? ` ${j.price_note}` : ""}`;
}

export default function JourneyCard({ journey, destinationMap = {} }) {
  const j = journey;
  const img = mediaUrl(j.card_image || j.hero_image) || FALLBACK_IMG;
  const linked = (j.destination_slugs || [])
    .map((s) => destinationMap[s])
    .filter(Boolean);

  return (
    <Link
      to={`/journeys/${j.slug}`}
      data-testid={`journey-card-${j.slug}`}
      className="group block"
    >
      <div className="aspect-[16/10] overflow-hidden bg-mist/30">
        <img
          src={img}
          alt={j.title}
          onError={(e) => { if (e.currentTarget.src !== FALLBACK_IMG) e.currentTarget.src = FALLBACK_IMG; }}
          className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
        />
      </div>
      <p className="eyebrow mt-5" data-testid={`journey-card-${j.slug}-meta`}>
        {j.duration_days ? `${j.duration_days} days` : "Bespoke duration"}
        {" · "}
        <span>{priceLabel(j)}</span>
      </p>
      <h3 className="mt-2 font-serif text-2xl md:text-3xl text-jade">{j.title}</h3>
      {j.summary && (
        <p className="mt-3 text-ink/70 text-[14px] font-light leading-relaxed line-clamp-3">
          {j.summary}
        </p>
      )}
      {linked.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-2" data-testid={`journey-card-${j.slug}-linked`}>
          {linked.map((d) => (
            <span
              key={d.slug}
              className="inline-block text-[10px] tracking-[0.18em] uppercase text-ink/60 border border-mist px-2.5 py-1"
            >
              {d.name}
            </span>
          ))}
        </div>
      )}
      <span className="mt-5 inline-flex items-center gap-2 text-[12px] tracking-[0.18em] uppercase text-jade group-hover:text-copper transition-colors">
        {j.cta_text || "View journey"} <ArrowRight strokeWidth={1} className="w-4 h-4" />
      </span>
    </Link>
  );
}
